import React from 'react'
import { TimeUtils } from '@front/volcanion/utils'

import moment from 'moment'

import { TableCell } from '@mui/material'
import { TextCell } from '@abra/elements/table/cells/basics/'

const getEstimatedTime = (row) => {
  if (!row?.info?.src_datetime || !row?.info?.dest_datetime) return '-'
  const duration = moment(row?.info?.dest_datetime).diff(moment(row?.info?.src_datetime), 'seconds')
  const format = duration >= 3600 ? 'H[h]mm[min]' : 'm[min]'
  return TimeUtils.secondsToTime(duration, format)
}

const Duration = ({ row }) => {
  const estimated_time = getEstimatedTime(row)
  return (
    <TableCell padding='none'>
      <TextCell fontSize={13} textAlign='center' value={!!estimated_time ? estimated_time : '-'} noWrap />
    </TableCell>
  )
}

export default React.memo(Duration)
